var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"main"},[_c('section',{staticClass:"page-404"},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"section-title section-title_white"},[_c('span',[_vm._v(_vm._s(_vm.$t('404.title')))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }